export default function modals(state = null, action) {
  switch (action.type) {
    case 'RECEIVE_MODAL':
      return { ...state, ...action.payload.modal }
    default:
      return state
  }
}
